// tslint:disable
export var ICustomerCodeV2;

(function (ICustomerCodeV2) {
  ICustomerCodeV2["RESI"] = "RESI";
  ICustomerCodeV2["SME"] = "SME";
  ICustomerCodeV2["MSP"] = "MSP";
})(ICustomerCodeV2 || (ICustomerCodeV2 = {}));